import { Observable, interval } from 'rxjs';
import { Actions } from '../../actions';
import * as earnings from '../../../sdk/earnings';
import {
  GetEarningsExportUrl,
  GetEarningsExportUrlError,
  GetEarningsExportUrlSuccess,
} from '../action-creators';
import { GET_EARNINGS_EXPORT_URL } from '../actions';
import { ofType } from 'redux-observable';
import { mergeMap, delayWhen } from 'rxjs/operators';

export const getEarningsExportUrlEpic = (
  action$: Observable<Actions>
): Observable<Actions> =>
  action$.pipe(
    ofType<Actions, GetEarningsExportUrl>(GET_EARNINGS_EXPORT_URL),
    delayWhen((action) => interval(1000 * action.retry)),
    mergeMap(async (action) => {
      try {
        const result = await earnings.getExportUrl(
          action.ownerId,
          action.requestId
        );

        if (result.status === 'processing' && action.retry < 5) {
          return new GetEarningsExportUrl(
            action.requestId,
            action.ownerId,
            action.retry + 1
          );
        }
        return new GetEarningsExportUrlSuccess(result.url);
      } catch (err) {
        //retry until export is created

        if ((err as Error) && action.retry < 5) {
          return new GetEarningsExportUrl(
            action.requestId,
            action.ownerId,
            action.retry + 1
          );
        }

        return new GetEarningsExportUrlError((err as Error).message);
      }
    })
  );
